export const ReviewsBlockTexts = {
  addReviewLinkLabel: 'Оставить отзыв',
};
